const dataSchema = require('../../entity/dataAccess/schema')

const schema = dataSchema.header

module.exports = schema
